import { createSlice } from "@reduxjs/toolkit";
import { UnallocatedPaymentResponseDto } from "../../shared/dtos/unallocatedPayment/UnallocatedPaymentResponseDto";
import {
  getInitialListState,
  generateListReducers,
} from "../utils/listFactory";

export const unallocatedPaymentSlice = createSlice({
  name: "unallocatedPayment",
  initialState: getInitialListState<UnallocatedPaymentResponseDto>(),
  reducers: {
    ...generateListReducers<UnallocatedPaymentResponseDto>(),
  },
});

export const unallocatedPaymentActions = unallocatedPaymentSlice.actions;
export default unallocatedPaymentSlice.reducer;
